import { render, staticRenderFns } from "./batchCreate.vue?vue&type=template&id=dbc23e12&scoped=true"
import script from "./batchCreate.vue?vue&type=script&lang=js"
export * from "./batchCreate.vue?vue&type=script&lang=js"
import style0 from "./batchCreate.vue?vue&type=style&index=0&id=dbc23e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc23e12",
  null
  
)

export default component.exports